import { useEffect } from 'react';
import { FEATURE_FLAGS } from '@highmark-web/highmark-common';
import { useGetAppFeatureFlag } from 'hooks/use-get-app-feature-flag.hook';
import { documentCenter } from '@leagueplatform/engen-capability-document-center';

export const useDynamicEnGenConfig = () => {
  const { isEnabled: isUMEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_UM_LETTERS,
  );
  const { isEnabled: isWelcomeGuidesEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_WELCOME_GUIDES,
  );
  const { isEnabled: isBenefitBookletEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_BENEFIT_BOOKLET,
  );
  const { isEnabled: isSbcEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_SBC,
  );
  const { isEnabled: isEOPEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_EOP,
  );
  const { isEnabled: isRecentErrHandleEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_RECENT_ERR_HANDLING,
  );
  const { isEnabled: isCMLettersEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_CASE_MANAGEMENT,
  );

  useEffect(() => {
    const dynamicFeatureFlags = {
      enableUMLetters: isUMEnabled,
      enableWelcomeGuides: isWelcomeGuidesEnabled,
      enableBenefitBooklet: isBenefitBookletEnabled,
      enableSBC: isSbcEnabled,
      enableEOP: isEOPEnabled,
      enableRecentErrorHandling: isRecentErrHandleEnabled,
      enableCMLetters: isCMLettersEnabled,
    };

    documentCenter.config(dynamicFeatureFlags);
  }, [
    isUMEnabled,
    isWelcomeGuidesEnabled,
    isBenefitBookletEnabled,
    isSbcEnabled,
    isEOPEnabled,
    isRecentErrHandleEnabled,
    isCMLettersEnabled,
  ]);
};
